import React from 'react';
import PropTypes from 'prop-types';
import Button from 'wonderbly-components/lib/Button';
import BreadCrumbItem from './BreadCrumbItem';
import './BreadCrumb.scss';

const BreadCrumb = props => (
  <div className="breadcrumb">
    {props.isCTAVisible ? (
      <Button unstyled onClick={props.onClickCTA} className="breadcrumb-cta">
        {props.breadcrumbCTA}
      </Button>
    ) : (
      props.items.map(item => (
        <BreadCrumbItem
          key={item.pageNumber}
          {...item}
          isActive={props.activePage === item.pageNumber}
          setActivePage={props.setActivePage}
          productCustomisation={props.productCustomisation}
          drawers={props.drawers}
        />
      ))
    )}
  </div>
);

BreadCrumb.propTypes = {
  activePage: PropTypes.number.isRequired,
  setActivePage: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      pageNumber: PropTypes.number.isRequired,
    }).isRequired,
  ),
  isCTAVisible: PropTypes.bool.isRequired,
  onClickCTA: PropTypes.func.isRequired,
  breadcrumbCTA: PropTypes.string,
  productCustomisation: PropTypes.object.isRequired,
  drawers: PropTypes.object.isRequired,
};

export default BreadCrumb;



// WEBPACK FOOTER //
// ./src/client/js/view/components/BreadCrumb/BreadCrumb.js